import { inject } from '@angular/core';
import { NativePresentationService } from '@core/services/native-shell/native-presentation.service';

export function nativePresentationInitializer(): void {
  inject(NativePresentationService).start();
}
